import React, {useContext, useEffect} from "react"
import {AssociatePerformanceContextV2} from "./context/AssociatePerformanceContextV2";
import {getRefreshInterval} from "../util/Util";
import {CapabilityContext} from "../global/context/CapabilityContext";
import AssociatePerformanceViewV2 from "./AssociatePerformanceViewV2";

const AssociatePerformanceV2 = (props) => {
    const {dispatch} = useContext(AssociatePerformanceContextV2);
    const {configViewModel} = useContext(CapabilityContext)

    const getData = () => {
        dispatch({
            type: 'LOAD_VIEW',
            data: {
                dispatcher: dispatch,
                baseUrl: configViewModel.baseUrl,
                stationConfig: configViewModel.stationConfig
            }
        });
    }

    useEffect(() => {
        getData()
        const interval = setInterval(() => {
            getData()
        }, getRefreshInterval(configViewModel.stationConfig));
        return () => clearInterval(interval);
    }, []);

    return (
        <div>
           <AssociatePerformanceViewV2 {...props}/>
        </div>
    );
}

export default AssociatePerformanceV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/AssociatePerformanceV2.js